/**
 * Phân loại các dòng master tại màn phương án phần bổ - Chi đầu tư phát triển
 */
export default {
  // Đầu năm
  BeginYear: 1,
  // Điều chỉnh
  Adjustment: 2,
  // Bổ sung
  Supplement: 3,
};
